module.exports = __webpack_public_path__ + "static/media/logo.b433c074.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 176
// module chunks = 0